export const FETCH_SUPERVISOR_WISE_OT_REQUEST = "FETCH_SUPERVISIOR_WISE_OT_REQUEST";
export const FETCH_SUPERVISOR_WISE_OT_SUCCESS = "FETCH_SUPERVISIOR_WISE_OT_SUCCESS";
export const FETCH_SUPERVISOR_WISE_OT_FAILURE = "FETCH_SUPERVISOR_WISE_OT_FAILURE";

export const FETCH_OT_EMP_NOTLEFT_REQUEST = "FETCH_OT_EMP_NOTLEFT_REQUEST";
export const FETCH_OT_EMP_NOTLEFT_SUCCESS = "FETCH_OT_EMP_NOTLEFT_SUCCESS";
export const FETCH_OT_EMP_NOTLEFT_FAILURE = "FETCH_OT_EMP_NOTLEFT_FAILURE";

export const FETCH_LOCATION_NOT_OFF_REQUEST = "FETCH_LOCATION_NOT_OFF_REQUEST";
export const FETCH_LOCATION_NOT_OFF_SUCCESS = "FETCH_LOCATION_NOT_OFF_SUCCESS";
export const FETCH_LOCATION_NOT_OFF_FAILURE = "FETCH_LOCATION_NOT_OFF_FAILURE";
